export default __webpack_public_path__ + "static/media/usa_digital_flag.db4c6d17.jpg";